module.exports = __webpack_public_path__ + "img/hourglass.194d9e59.png";